import React, { useEffect, useRef, useState } from "react";
import mobileicon from "../../assets/images/mobileicon.svg";
import Email from "../../assets/images/email.svg";
import qrcode from "../../assets/images/qrcode.png";
import { Form, Spinner } from "react-bootstrap";
import greenverification from "../../assets/images/greenverification.svg";
import closeeye from "../../assets/images/closeEye.svg";
import openeye from "../../assets/images/viewaction.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  Disable2FA,
  Enable2FA,
  Send2FAEmailOTP,
  Verify2FA,
} from "../../services/ReduxTookit/Slice/AuthFlowRedux";
import { toast } from "react-toastify";
import VerifyEmailOTP from "../2FAModels/VerifyEmailOTP";
import { GetByPrimarykey } from "../../services/ReduxTookit/Slice/UserRedux";
import { userInfo } from "../../services/ReduxTookit/UserInfoSlice";
import DisableModal from "../Disable";
import { API_URL } from "../../services/APIRoute";
import SubmitLoading from "../../component/common-component/Loaders/SubmitLoading";
import ChangePassword from "../2FAModels/ChangePassword";
import MainpageLoader from "../../component/common-component/Loaders/MainpageLoader";

const AuthenticationManagementModel = ({ setPasswordPass, passwordPass }) => {
  let Userdata = useSelector((state) => state?.userinfo?.UserInfo);

  let Auth2FAData = useSelector(
    (state) => state?.authflowredux?.Enable2FAData?.data?.data?.data
  );

  const dispatch = useDispatch();
  const [changePass, setChangePass] = useState(false);

  const [otpTimer, setOtpTimer] = useState(0);
  const [AuthOTP, setAuthOTP] = useState(false);
  const [enable2fa, setenable2fa] = useState(false);

  const [proceedData, setProceedData] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("");
  const [inputAuth, setInputAuth] = useState();
  const [loader, setLoader] = useState(false);
  const [disableModalShow, setDisableModalShow] = useState(false);
  const Call2FAVerifyFunction = () => {
    if (inputAuth?.length === 6) {
      setLoader(true);
      dispatch(
        Verify2FA({
          userid: Auth2FAData?.uid,
          code: inputAuth,
          frompage: "2FA",
        })
      )?.then((res) => {
        setLoader(false);
        if (res?.payload?.isValidate) {
          dispatch(GetByPrimarykey({})).then((response) => {
            if (response?.payload?.isValidate) {
              dispatch(userInfo(response?.payload?.data?.data));
            }
          });
        } else {
          setAuthOTP(true);
          setInputAuth("");
        }
      });
    } else {
      setAuthOTP(true);
      toast.error("Please add 6 digit verification code");
    }
  };

  const DisableAuthentication = () => {
    // dispatch(Disable2FA({})).then((response) => {
    //   if (response?.payload?.isValidate) {
    dispatch(GetByPrimarykey({})).then((response) => {
      if (response?.payload?.isValidate) {
        dispatch(userInfo(response?.payload?.data?.data));
      }
    });
    //   }
    // });
  };
  useEffect(() => {
    if (otpTimer > 0) {
      const timer = setInterval(() => {
        setOtpTimer(otpTimer - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [otpTimer]);
  useEffect(() => {
    setenable2fa(passwordPass);
    setProceedData("");
    setChangePass(false);
  }, [passwordPass]);
  useEffect(() => {
    setPasswordPass(enable2fa);
  }, [enable2fa]);
  useEffect(() => {
    if (Userdata?.istwostepenable === true) {
      setenable2fa(true);
    }
    if (Userdata?.twofactortype === "AuthenticatorApp") {
      setSelectedMethod("authApp");
    }
    if (Userdata?.twofactortype === "Email") {
      setSelectedMethod("email");
    }
  }, [Userdata]);

  const handleSelection = (method) => {
    setSelectedMethod(method);
  };
  return (
    <>
      {loader && <MainpageLoader />}
      <div className="passwordauthentication-main">
        {Userdata?.logintype === "UserName" ? (
          <>
            {" "}
            <div className="profile-common-title">
              {" "}
              <h3>Password</h3>
            </div>
            <div className="profile-common">
              <div className="password-profile">
                <p>
                  Update your password regularly to keep your account secure.
                  Enter your current password, then set a new one to complete
                  the change.
                </p>
                {!changePass && (
                  <button
                    className="grey-btn "
                    onClick={() => {
                      setChangePass(true);
                      setenable2fa(false);
                    }}
                  >
                    Change Password
                  </button>
                )}
              </div>
              {changePass && <ChangePassword setChangePass={setChangePass} />}
            </div>
          </>
        ) : (
          <></>
        )}
        {enable2fa && !proceedData ? (
          <>
            <div className="profile-common-title">
              {" "}
              <h3>Two-Factor Authentication</h3>
            </div>
            <div className="profile-common">
              <div className="twofactor-auth">
                <div className="twofactor-auth-inner">
                  <p>
                    Set your preferred method for Two-Factor Authentication to
                    enhance the security of your account, such as via
                    Authentication app or Email.
                  </p>
                  <h4>Two-Factor Method</h4>
                  <div className="twofactor-selector">
                    <div
                      className={`option ${
                        selectedMethod === "authApp" ? "selected" : ""
                      }`}
                      onClick={() => handleSelection("authApp")}
                    >
                      <input
                        type="radio"
                        id="auth-app"
                        name="2fa-method"
                        checked={selectedMethod === "authApp"}
                        readOnly
                      />
                      <label htmlFor="auth-app">
                        <div className="d-flex align-item-center">
                          <h4>
                            {" "}
                            <span>
                              <img src={mobileicon} alt="mobileicon" />
                            </span>{" "}
                            <span className="Authenticatortext">
                              Authenticator App
                            </span>{" "}
                            {Userdata?.twofactortype === "AuthenticatorApp" && (
                              <span className="green-badge">Configured</span>
                            )}
                          </h4>
                        </div>
                        <p>
                          Use an authentication app or browser extension to
                          generate secure, time-sensitive codes for your 2FA
                          verification.
                        </p>
                      </label>
                      {Userdata?.twofactortype === "AuthenticatorApp" && (
                        <button
                          className="grey-btn width75 d-flex justify-content-center"
                          onClick={() => setDisableModalShow(true)}
                        >
                          Disable
                        </button>
                      )}
                    </div>

                    <div
                      className={`option ${
                        selectedMethod === "email" ? "selected" : ""
                      }`}
                      onClick={() => handleSelection("email")}
                    >
                      <input
                        type="radio"
                        id="email-auth"
                        name="2fa-method"
                        checked={selectedMethod === "email"}
                        readOnly
                      />
                      <label htmlFor="email-auth">
                        <div className="d-flex align-item-center">
                          <h4>
                            {" "}
                            <span>
                              <img src={Email} alt="Email" />
                            </span>{" "}
                            <span className="Authenticatortext">
                              Email Authentication
                            </span>{" "}
                            {Userdata?.twofactortype === "Email" && (
                              <span className="green-badge">Configured</span>
                            )}
                          </h4>
                        </div>
                        <p>
                          Receive your 2FA verification code directly to your
                          registered email address for added security during
                          login.
                        </p>
                      </label>
                      {Userdata?.twofactortype === "Email" && (
                        <button
                          className="grey-btn width75 d-flex justify-content-center"
                          onClick={() => setDisableModalShow(true)}
                        >
                          Disable
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="popup-footer d-flex justify-content-end">
                  {!Userdata?.twofactortype && (
                    <>
                      {" "}
                      <button
                        className="grey-btn width150"
                        // id="add-project"
                        onClick={(e) => {
                          setenable2fa(false);
                        }}
                      >
                        Cancel
                      </button>{" "}
                      <button
                        className="blue-btn width150"
                        onClick={() => {
                          if (selectedMethod === "authApp") {
                            setProceedData("authApp");
                            dispatch(Enable2FA({}))?.then((res) => {});
                          }

                          if (selectedMethod === "email") {
                            setProceedData("email");
                          }
                          if (selectedMethod === "") {
                            toast.error("Please select Two-Factor Method");
                          }
                        }}
                      >
                        Proceed
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {!proceedData && (
              <>
                {" "}
                <div className="profile-common-title">
                  {" "}
                  <h3>Two-Factor Authentication</h3>
                </div>
                <div className="profile-common">
                  <div className="twofactor-profile">
                    <h3>
                      Enhance Your Security with Two-Factor Authentication
                    </h3>
                    <p>
                      Add an extra layer of protection to your account by
                      enabling Two-Factor Authentication. This simple, secure
                      setup helps safeguard your data with a unique verification
                      code each time you log in.
                    </p>

                    <div className="d-flex justify-content-center">
                      <button
                        className="green-btn "
                        // id="add-project"
                        onClick={() => {
                          setenable2fa(true);
                          setChangePass(false);
                        }}
                      >
                        Enable Two-Factor Authentication
                      </button>
                    </div>
                    <h5>
                      {/* <a
                        href="https://quantum-data-assets.s3.us-east-1.amazonaws.com/Two+Factor+File/Two+Factor+Authentication.pdf"
                        target="_blank"
                      >
                        Learn More
                      </a> */}
                    </h5>
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {proceedData === "authApp" && (
          <>
            <div className="profile-common-title">
              {" "}
              <h3>Two-Factor Authentication</h3>
            </div>
            <div className="profile-common">
              <div className="authenticator-app">
                <h4>Authenticator App Setup</h4>
                <p>
                  Scan the QR code with your authentication app to link it to
                  your account. Enter the code generated to complete setup.
                </p>

                {!Auth2FAData ? (
                  <div className="qrcode-loader">
                    <img src={qrcode} alt="qrcode" />
                    <Spinner animation="border" variant="light" />
                  </div>
                ) : (
                  <img src={Auth2FAData?.qrcode} alt="qrcode" />
                )}

                <Form.Group className="form-group">
                  <Form.Label className="login-label">
                    Verify Code From App
                    <span className="ms-1 red-color-text"></span>
                  </Form.Label>
                  <div className="input-type-pass">
                    <Form.Control
                      style={{
                        border:
                          inputAuth?.length === 6
                            ? ""
                            : AuthOTP
                            ? "1px solid red"
                            : "1px solid var(--blue2b)",
                      }}
                      placeholder="XXXXXX"
                      className="login-input"
                      maxLength={6}
                      value={inputAuth}
                      onChange={(e) => {
                        setInputAuth(e.target.value);
                      }}
                      onKeyUp={(e) => {
                        if (inputAuth?.length === 6 && e.key === "Enter") {
                          Call2FAVerifyFunction();
                        }
                      }}

                      // isInvalid={input?.errors?.Password}
                    />
                    {inputAuth?.length === 6 && (
                      <img src={greenverification} alt="greenverification" />
                    )}
                  </div>
                </Form.Group>
                <div className="popup-footer d-flex justify-content-end">
                  <button
                    className="grey-btn width150"
                    onClick={(e) => {
                      setProceedData("");
                      setAuthOTP(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="blue-btn width150"
                    onClick={() => Call2FAVerifyFunction()}
                    disabled={loader}
                  >
                    {loader ? (
                      // <>
                      //   <span>Loading</span>{" "}
                      //   <Spinner
                      //     className="ms-1"
                      //     animation="border"
                      //     role="status"
                      //     size="sm"
                      //   >
                      //     <span className="visually-hidden">Loading...</span>
                      //   </Spinner>
                      // </>
                      <SubmitLoading />
                    ) : (
                      "Verify"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {proceedData === "email" && (
          <>
            <VerifyEmailOTP
              uid={Userdata?.uid}
              setProceedData={setProceedData}
            />
          </>
        )}
      </div>
      {disableModalShow && (
        <DisableModal
          payload={{}}
          method="POST"
          url={API_URL.AUTH.DISABLE_2FA}
          show={disableModalShow}
          bindlist={DisableAuthentication}
          onHide={(e) => setDisableModalShow(false)}
        />
      )}
    </>
  );
};

export default AuthenticationManagementModel;
